<template>
  <a-card title="首页Banner">
    <a-tabs v-model:activeKey="formSearch.position" @change="handleTableChange()" >
      <a-tab-pane key="top" tab="顶部 Banner"></a-tab-pane>
      <a-tab-pane key="bottom" tab="底部 Banner"></a-tab-pane>
      <a-tab-pane key="activity" tab="活动Banner"></a-tab-pane>
    </a-tabs> 
    <a-tabs v-model:activeKey="formSearch.region_code" @change="handleTableChange()" >
      <a-tab-pane key="" tab="全部"></a-tab-pane>
      <a-tab-pane key="CN" tab="中国 CN"></a-tab-pane>
      <a-tab-pane key="US" tab="美国 US"></a-tab-pane>
    </a-tabs> 
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item label="标题" name="title">
          <a-input placeholder="标题" v-model:value="formSearch.title" />
        </a-form-item>
        <a-form-item label="任务类型" name="style_id">
          <a-select
            style="width: 230px;"
            v-model:value="formSearch.style_id"
            :options="TaskStyleGroupOptions"
            placeholder="任务类型 ID"
          />
        </a-form-item>
        <a-form-item label="地区" name="region_code">
          <a-input placeholder="地区" v-model:value="formSearch.region_code" />
        </a-form-item>
        <a-form-item  label="状态"  name="status">
          <a-select
            style="width: 100px;"
            v-model:value="formSearch.status"
            :options="status"
          />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            @click="handleCreate"
          >
          新建
          </a-button>
        </a-form-item>
      </a-form>
    </a-space>

    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
    <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange()"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
      <!-- <template #style_name="{ record }">
        {{ styleNames[record.style_id]}}
      </template> -->
      <template #image_url="{ record }">
        <a-image
          style="width: 100px;"
          placehoder="true"
          :src="record.image_url" width="100"
        />
      </template>
      <template #sort="{ record }">
        <a-input-group compact>
          <a-input v-model:value="record.sort"  style="width: 60px;" />
          <a-button type="primary" @click="handleModifySort(record)"  >设置</a-button>
        </a-input-group>
      </template>
      <template #status="{ record }">
        <a-tag v-if="record.status == 1" color="green">已上线</a-tag>
        <a-tag v-if="record.status == 0" color="gray">已下线</a-tag>
        <a-tag v-if="record.status == 2" color="yellow">预览中</a-tag>
      </template>
      <template #action="{ record }">
       <a-space>
        <a-button @click="handleModifyStatus(record, '1')" v-if="record.status == 2" type="primary">上线</a-button>
        <a-button @click="handleModifyStatus(record, '0')"  v-if="record.status == 2 || record.status == 1"  danger >下线</a-button>
        <a-button @click="handleModifyStatus(record, '2')"  v-if="record.status == 0"  warning >测试环境预览</a-button>
        <a-button  warn @click="handleUpdate(record)"  >编辑</a-button>
        <a-popconfirm
          title="确定删除吗?"
          ok-text="确定"
          cancel-text="不了"
          @confirm="handleDelete(record)"
        >
          <a-button v-if="record.status == 0"   danger   >删除</a-button>
        </a-popconfirm>
       </a-space>
      </template>
      </a-table>
  </a-card>
  <a-modal v-model:visible="openDia" :title="formRecord.id == 0 ? '新建' : '编辑'" @cancel="resetForm" @ok="handleConfirm" :confirm-loading="loading">
    <a-form :label-col="{ span: 8 }" :model="formRecord" :disabled="formRecord.status != 0"  style="margin: 10px auto;" :rules="rules" ref="formRef" >
        <a-form-item required label="标题" name="title">
          <a-input placeholder="标题" v-model:value="formRecord.title" />
        </a-form-item>
        <a-form-item required label="视频" name="video_url">
          <UploadVideo v-model:videoURL="formRecord.video_url"  />
          <a-input placeholder="refer_url" v-model:value="formRecord.video_url" />
        </a-form-item>
        <a-form-item required label="封面" name="image_url">
          <Upload v-model:imageUrl="formRecord.image_url"  />
          <a-input placeholder="refer_url" v-model:value="formRecord.image_url" />
        </a-form-item>
        <a-form-item required label="最低支持版本" name="min_app_version">
          <a-input placeholder="最低支持版本" v-model:value="formRecord.min_app_version" />
        </a-form-item>
        <a-form-item required label="国家地区" name="region_code">
          <a-input placeholder="国家地区" v-model:value="formRecord.region_code" />
        </a-form-item>
         <a-form-item label="性别"  name="gender">
          <a-select
            v-model:value="formRecord.gender"
            :options="[{
              value: '',
              label: '无'
            },{
              value: 'male',
              label: '男'
            },{
              value: 'female',
              label: '女'
            }]"
            placeholder="性别"
          />
        </a-form-item>
        <a-form-item required label="Banner 位置"  name="position">
          <a-select
            v-model:value="formRecord.position"
            :options="[{
              value: 'top',
              label: '首页顶部'
            },{
              value: 'bottom',
              label: '首页底部'
            },{
              value: 'activity',
              label: '活动Banner'
            }]"
            placeholder="Banner 位置"
          />
        </a-form-item>
        <a-form-item required label="排序" name="sort">
          <a-input placeholder="sort" v-model:value="formRecord.sort" />
        </a-form-item>

       
        <a-form-item  >
          <a-alert message="以下是点击行为控制" type="info" show-icon style="text-align: left;"  />
        </a-form-item>
        <a-form-item  label="跳转地址"  name="redirect_uri">
          <a-input placeholder="redirect_uri" v-model:value="formRecord.redirect_uri" />
          <a-alert message="如有则「忽略」以下的任务调整配置" type="warning" show-icon  />
        </a-form-item>
          <a-form-item  label="工具"  name="tool_id">
          <a-select
            v-model:value="formRecord.tool_id"
            :options="ToolIdOptions"
            placeholder="ToolID"
          />
        </a-form-item>
        <a-form-item  label="任务类型"  name="style_id">
          <a-select
            v-model:value="formRecord.style_id"
            style="width: 230px;"
            :options="TaskStyleGroupOptions"
            placeholder="StyleID"
          />
        </a-form-item>
        <a-form-item  label="任务子类型"  name="sub_type">
          <a-select
            v-model:value="formRecord.sub_type"
            :options="SubTypeOptions"
            placeholder="SubType"
          />
        </a-form-item>
        <a-form-item label="默认提示词" name="prompt">
          <a-input placeholder="prompt" v-model:value="formRecord.prompt" />
        </a-form-item>
        <a-form-item label="垫图" name="refer_url">
          <Upload v-model:imageUrl="formRecord.refer_url"  />
          <a-input placeholder="refer_url" v-model:value="formRecord.refer_url" />
        </a-form-item>
        <a-form-item label="选项（模板）" name="option_id">
          <a-input placeholder="option_id" v-model:value="formRecord.option_id" />
        </a-form-item>
        <a-form-item label="特征值" name="value">
          <a-input placeholder="value" v-model:value="formRecord.value" />
        </a-form-item>
      </a-form>
  </a-modal>
  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import request from '@/utils/request'
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex'
import Upload from '@/components/Upload.vue'
import UploadVideo from '@/components/UploadVideo.vue'

import { TaskStyleGroupOptions, SubTypeOptions, ToolIDOptions } from '@/utils/macro'

const DefaultRecord = {
  "id": 0,
  "title": "",
  "style_id": "",
  "redirect_uri": "",
  "video_url": "",
  "image_url": "",
  "min_app_version": "1.5.00",
  "region_code": "CN",
  "prompt": "",
  "refer_url": "",
  "option_id": "",
  "value": "",
  "status": 0,
  "position": "top",
  "sort":"100",
  "sub_type": "",
  "gender": "",
}
export default defineComponent({
  components: {
    Upload,UploadVideo,
    SearchOutlined
  },
  data(){
    return {
      TaskStyleGroupOptions,
      SubTypeOptions: SubTypeOptions,
      ToolIdOptions: ToolIDOptions,
      styleNames :{},
      loading: false,
      openDia: false,
      dataSource: [],
      action_image_index: 0,
      formRecord: {
        ...DefaultRecord
      },
      rules:{
        title: [
          { required: true, message: 'required', trigger: 'change' },
        ],
      },
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
      status: [
      {
          label: '全部',
          value: ''
        },
        {
          label: '上线',
          value: '1'
        },
        {
          label: '下线',
          value: '0'
        },
        {
          label: '预览',
          value: '2'
        },
      ],
       formSearch: {
        title:'',
        status: '',
        style_id: '',
        position: 'top',
        region_code: '',
      },
      searchPosition : 'top',
      uploadLoading: false,
    }
  },
  mounted(){
    this.handleTableChange()
  },
  methods: {
    async handleConfirm(){
      if (this.formRecord.id) {
        const rsp = await request.put(`/api/home_banners/${this.formRecord.id}`, {
          ...this.formRecord,
          video_url: this.formRecord.video_url.replaceAll("http://statica.xuantu.pro/", ""),
          image_url: this.formRecord.image_url.replaceAll("http://statica.xuantu.pro/", ""),
          width: +this.formRecord.width,
          height: +this.formRecord.height,
        })
      } else {
        const rsp = await request.post('/api/home_banners/create', {
          ...this.formRecord,
          video_url: this.formRecord.video_url.replaceAll("http://statica.xuantu.pro/", ""),
          image_url: this.formRecord.image_url.replaceAll("http://statica.xuantu.pro/", ""),
          sort: +this.formRecord.sort,
          width: +this.formRecord.width,
          height: +this.formRecord.height,
        })
      }
     
      this.openDia = !this.openDia
      this.loading = false
      this.handleTableChange()
    },
    handleCreate(){
      this.openDia = true
      let data = {
        ...DefaultRecord
      }
      this.formRecord = data
    },
    handleUpdate(record){
      this.openDia = true
      let data = {
        ...record
      }
      this.formRecord = data
    },
    async handleDelete(record){
      this.loading = true
      await request.delete(`/api/home_banners/${record.id}`, { })
      this.loading = false
      this.handleTableChange()
    },
    async handleModifySort(record){
      this.loading = true
      await request.put(`/api/home_banners/${record.id}`, {
        sort: +record.sort,
      })
      this.loading = false
      this.handleTableChange()
    },
    async handleModifyStatus(record, status){
      this.loading = true
      await request.put(`/api/home_banners/${record.id}`, {
        status: +status,
      })
      this.loading = false
      this.handleTableChange()
    },
    resetForm() {
      this.$refs.formRef.resetFields();
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      try {
        const rsp = await request.get('/api/home_banners/search', {
          offset: (pagi.current - 1) * pagi.pageSize ,
          limit: pagi.pageSize,
          ...this.formSearch
        })
        this.loading = false
        // 确保数据安全处理
        if (rsp && rsp.data) {
          this.dataSource = [].concat(rsp.data.list || [])
          if (rsp.data.pagination) {
            this.noticeMessage = `共 ${rsp.data.pagination.total || 0} 条`
            this.pagination.total = rsp.data.pagination.total || 0
          } else {
            this.noticeMessage = '共 0 条'
            this.pagination.total = 0
          }
        } else {
          this.dataSource = []
          this.noticeMessage = '共 0 条'
          this.pagination.total = 0
        }
        this.pagination.current = pagi.current
        this.pagination.pageSize = pagi.pageSize
      } catch (error) {
        console.error('获取数据失败:', error)
        this.loading = false
        this.dataSource = []
        this.noticeMessage = '共 0 条'
        this.pagination.total = 0
        this.pagination.current = pagi.current
        this.pagination.pageSize = pagi.pageSize
      }
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '任务类型',
          dataIndex: 'style_id',
          key: 'style_id',
          slots: { customRender: 'style_name' },

        },
        {
          title: '标题',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: '封面图',
          dataIndex: 'image_url',
          key: 'image_url',
          slots: { customRender: 'image_url' },
        },
        {
          title: '地区',
          dataIndex: 'region_code',
          key: 'region_code',
        },
        {
          title: '最低支持版本',
          dataIndex: 'min_app_version',
          key: 'min_app_version',
        },
        {
          title: 'Banner 位置',
          dataIndex: 'position',
          key: 'position',
        },
        {
          title: '性别',
          dataIndex: 'gender',
          key: 'gender',
        },
        {
          title: '排序',
          slots: { customRender: 'sort' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at',
        },
        {
          title: '修改时间',
          dataIndex: 'updated_at',
          key: 'updated_at',
        },
        {
          title: '操作人 ID',
          dataIndex: 'operator_id',
          key: 'operator_id',
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>